import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { User, BookOpen, GraduationCap, Star } from "lucide-react";
import "./ClassCards.css";

const ClassCards = () => {
  const navigate = useNavigate();
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("darkMode");
    if (saved === "true") setDarkMode(true);

    // جلب بيانات المدرسين من الـ API
    const fetchTeachers = async () => {
      try {
        const response = await axios.get("https://leader-acadmy.hwnix.com/api/teachers");
        if (response.data.status) {
          setTeachers(response.data.teachers);
        }
      } catch (error) {
        console.error("Error fetching teachers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTeachers();
  }, []);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>جاري تحميل قائمة المبدعين...</p>
      </div>
    );
  }

  return (
    <section className={`section-teachers ${darkMode ? "dark-mode" : ""}`}>
      <div className="container-header">
        <h2 className="section-main-title">نخبة من أفضل المعلمين</h2>
        <p className="section-subtitle">اختر مدرسك وابدأ رحلة النجاح مع Edu Masr</p>
      </div>

      <div className="teachers-grid">
        {teachers.map((teacher, index) => (
          <div className="teacher-card" key={index}>
            <div className="card-image-wrapper">
              {teacher.image && teacher.image !== "https://leader-acadmy.hwnix.com/storage" ? (
                <img src={teacher.image} alt={teacher.name} className="teacher-img" />
              ) : (
                <div className="teacher-placeholder">
                  <User size={60} color="#fff" />
                </div>
              )}
              <div className="subject-badge">
                <BookOpen size={14} />
                <span>{teacher.subject}</span>
              </div>
            </div>

            <div className="teacher-card-content">
              <div className="rating-row">
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={14} fill="#f1c40f" color="#f1c40f" />
                  ))}
                </div>
                <span className="rating-num">(5.0)</span>
              </div>

              <h3 className="teacher-name">{teacher.name}</h3>
              
              <div className="education-levels">
                <GraduationCap size={16} className="icon-grad" />
                <div className="levels-tags">
                  {teacher.educational_levels.length > 0 ? (
                    teacher.educational_levels.map((level, i) => (
                      <span key={i} className="level-tag">{level}</span>
                    ))
                  ) : (
                    <span className="level-tag">جميع المراحل</span>
                  )}
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ClassCards;